import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { RegisterForm } from "@/features/auth/components/RegisterForm"
import { AuthLayout } from "@/features/auth/components/AuthLayout"

export const Route = createFileRoute("/auth/register/")({
    component: RegisterPage,
})

function RegisterPage() {
    const navigate = useNavigate()

    return (
        <AuthLayout>
            <RegisterForm
                onLoginClick={() => navigate({ to: "/auth/login" })}
                onSuccess={(email) => navigate({
                    to: "/auth/verify",
                    search: { email }
                })}
            />
        </AuthLayout>
    )
}
